import styled from 'styled-components'
import { mainColor, mainFont } from '../../styles/global';


export const SavingsWrapper = styled.div`
    padding:3% 5%;
      
`;

export const SavingsHeader = styled.div`
    display:flex;
    justify-content:center;
    align-items:center;
    gap:3rem;
    // height:100vh; 
    height:fit-content;
    @media screen and (max-width: 768px) {
        flex-direction: column;
        gap:0rem;
        height:fit-content;
    }
`;


export const RightSection = styled.div`
    flex:0.5;
    margin-top:80px;
    img{
        height:90%;
        width:90%;
    }
    @media screen and (max-width: 768px) {
        display:flex;
        justify-content: center;
        align-items: center;
        img{
            height:80%;
            width:80%;
        }
    }
`;
export const  LeftSection = styled.div`
    flex:0.5;
    h3{
        font-family: 'Avenir';
        font-style: normal;
        font-weight: 500;
        font-size: 46.5434px;
        line-height: 60px;
        // letter-spacing: 0.01em;
        color:${mainColor};
        margin-bottom:20px;
    }
    @media screen and (max-width: 768px) {
        h3{
            font-weight: 500;
            font-size: 27px;
            line-height: 33px;
        }
    }

`;
export const SavingsTextHeader = styled.div`
        font-family: ${mainFont};
        font-style: normal;
        font-weight: 500;
        font-size: 46.5434px;
        width:70%;
        text-align: justify;
        letter-spacing: 0.01em;
        color: ${mainColor};
        margin:5rem auto 0 auto;
        @media screen and (max-width: 768px) {
            font-weight: 600;
            width:90%;
            font-size: 18px;
            line-height: 34px;
            text-align: justify;
            margin:2rem auto 0 auto;

        }
`;
export const CenterText = styled.div`
    padding:30px 15%;

h3{
    font-family: ${mainFont};
    font-style: normal;
    font-weight: 500;
    font-size: 46.5434px;
    line-height: 60px;
    // letter-spacing: 0.01em;
    color:${mainColor};
    margin-top:50px;
    margin-bottom:20px;
    text-align: justify;
}
@media screen and (max-width: 768px) {
    padding:0;

    h3{
        font-weight: 500;
        font-size: 23px;
        line-height: 33px;
    }
}
`;



export const ShortTermSavingGridBox = styled.div`
        display:flex;
        justify-content:center;
        align-items: center;
        gap:2rem;
        flex-wrap: wrap;
        margin-top:4rem;
        @media screen and (max-width: 768px) {
            flex-direction: column;
        }

`;

export const StoryBox = styled.div`
        width:calc(50% - 2rem);
        height:200px;
        padding:5% 3%;
        background:#FDF2F5;
        display:flex;
        flex-direction: column;
        justify-content:center;
        align-items: center;
        position:relative;
        border-radius: 9px;
        margin-top:30px;
        >h3{
            font-family: ${mainFont};
            color:${mainColor};
            font-style: normal;
            font-weight: 750;
            // margin-top:20px;
            font-size: 21.3659px;
            line-height:50px;
            text-align: justify;
            letter-spacing: 0.01em;
        }

        >div{
            border:1px solid black;
            padding:5px;
            height:60px;
            width:60px;
            border-radius:60px;
            background:#fff;
            display:flex;
            justify-content:center;
            align-items: center;
            position: absolute;
            top: -0;
            left:50%;
            transform: translate(-50%, -50%);
        }
        p{
            font-family: 'Avenir';
            font-style: normal;
            font-weight: 400;
            font-size: 17px;
            line-height: 26px;
            text-align: justify;
            letter-spacing: 0.01em;
            color: #8D8D8D;
        }
        @media screen and (max-width: 768px) {
            width:100%;
            height:150px;
            > div{
                height:50px;
                width:50px;
                border-radius:50px;
            }
            p{
                font-family: 'Avenir';
                font-style: normal;
                font-weight: 400;
                font-size: 10.1319px;
                line-height: 15px;
                text-align: justify;
                letter-spacing: 0.01em;
                color: #8D8D8D;
            }
        }

`;

export const SavingsText = styled.div`
        padding:30px 10%;
        margin-top:40px;
        @media screen and (max-width: 768px) {
            padding:0;

        }
    
`;





